import { createStore as createReduxStore, applyMiddleware, combineReducers, compose } from 'redux';
import { LoggingMiddleware } from '@chr/common-javascript-logging-redux-middleware';
import createSagaMiddleware from 'redux-saga';
import { all, call } from 'redux-saga/effects';
import { AppState } from 'react-app-env';
import { watchGetWidgets } from './common/sagas/getWidgetsSaga';
import { watchDeleteWidget, watchResetWidgets, watchUpdateWidget, watchAddWidget } from './common/sagas/modifyWidgetsSaga';
import widgetReducer from './common/reducers/widgetReducer';
import visibilityUserSettingsReducer from './common/reducers/visibilityUserSettingsReducer';
import { watchSaveWidgetsLayoutToDb } from './common/sagas/saveLayoutsToDbSaga';
import { watchFetchUserSettings } from './common/sagas/visibilityUserSettingsSaga';

export const rootReducer = combineReducers<AppState>({
  // put all your area and common reducers here
  widgetsState: widgetReducer,
  userSettingsState: visibilityUserSettingsReducer
});

const rootSaga = function* rootSaga() {
  yield all({
    // put all your area and common sagas here
    watchAddWidget: call(watchAddWidget),
    watchUpdateWidget: call(watchUpdateWidget),
    watchDeleteWidget: call(watchDeleteWidget),
    watchGetWidgets: call(watchGetWidgets),
    watchResetWidgets: call(watchResetWidgets),
    watchWidgetLayout: call(watchSaveWidgetsLayoutToDb),
    watchFetchUserSettings: call(watchFetchUserSettings)
  });
};

export const createStore = () => {
  let composeEnhancers = compose;
  const devToolsCompose = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
  /* istanbul ignore if  */
  if (devToolsCompose) {
    composeEnhancers = devToolsCompose;
  }
  const sagaMiddleware = createSagaMiddleware();
  const middlewares = [sagaMiddleware, LoggingMiddleware];
  const store = createReduxStore(
    rootReducer,
    composeEnhancers(
      applyMiddleware(...middlewares),
    ),
  );
  sagaMiddleware.run(rootSaga);
  return store;
};
